import {
  Rarity,
  OwnershipStatus,
} from './constants';
import typeHints from './typeHints';

const attributes = {

  inventory_no: {
    friendly: 'Inventory No.',
    validations: {
      maxLength: 255,
    },
  },

  quantity: {
    friendly: 'Quantity',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },

  title: {
    friendly: 'Title',
    validations: {
      isRequired: true,
      maxLength: 255,
    },
  },

  description: {
    friendly: 'Description',
    validations: {},
    typeHint: typeHints.TextArea,
  },

  rarity: {
    friendly: 'Rarity',
    validations: {
      type: 'enum',
      enumType: Rarity,
    },
  },

  market_value: {
    friendly: 'Market Value',
    validations: {
      type: 'decimal',
    },
    typeHint: typeHints.Monetary,
  },

  accessories: {
    friendly: 'Accessories',
    validations: {},
  },

  tags: {
    friendly: 'Tags',
    validations: {
      maxLength: 255,
    },
  },

  notes: {
    friendly: 'Notes',
    validations: {},
    typeHint: typeHints.TextArea,
  },

  item_history: {
    friendly: 'Item History',
    validations: {},
    typeHint: typeHints.TextArea,
  },

  ownership_contact: {
    friendly: 'Ownership Contact',
    validations: {
      type: 'foreignKey',
    },
    typeHint: typeHints.Contact,
  },

  purchase_date: {
    friendly: 'Purchase Date',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  purchase_contact: {
    friendly: 'Seller',
    validations: {
      type: 'foreignKey',
    },
    typeHint: typeHints.Contact,
  },

  purchase_price: {
    friendly: 'Purchase Price',
    validations: {
      type: 'decimal',
    },
    typeHint: typeHints.Monetary,
  },

  purchase_notes: {
    friendly: 'Notes',
    validations: {},
    typeHint: typeHints.TextArea,
  },

  appraisal_contact: {
    friendly: 'Appraisal Company',
    validations: {
      type: 'foreignKey',
    },
    typeHint: typeHints.Contact,
  },

  appraisal_date: {
    friendly: 'Appraisal Date',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  appraisal_value: {
    friendly: 'Appraisal Value',
    validations: {
      type: 'decimal',
    },
    typeHint: typeHints.Monetary,
  },

  appraisal_cost: {
    friendly: 'Appraisal Cost',
    validations: {
      type: 'decimal',
    },
    typeHint: typeHints.Monetary,
  },

  appraisal_notes: {
    friendly: 'Notes',
    validations: {},
    typeHint: typeHints.TextArea,
  },

  insurance_contact: {
    friendly: 'Insurance Company',
    validations: {
      type: 'foreignKey',
    },
    typeHint: typeHints.Contact,
  },

  insurance_policy_number: {
    friendly: 'Policy No.',
    validations: {
      maxLength: 45,
    },
  },

  insurance_policy_start: {
    friendly: 'Policy Period Start',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  insurance_policy_end: {
    friendly: 'Policy Period End',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  insurance_value: {
    friendly: 'Insurance Value',
    validations: {
      type: 'decimal',
    },
    typeHint: typeHints.Monetary,
  },

  insurance_notes: {
    friendly: 'Notes',
    validations: {},
    typeHint: typeHints.TextArea,
  },

  grading_contact: {
    friendly: 'Grading Company',
    validations: {
      type: 'foreignKey',
    },
    typeHint: typeHints.Contact,
  },

  grading_date: {
    friendly: 'Grading Date',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

  grading_cost: {
    friendly: 'Grading Cost',
    validations: {
      type: 'decimal',
    },
    typeHint: typeHints.Monetary,
  },

  grading_grade: {
    friendly: 'Grade',
    validations: {
      maxLength: 100,
    },
  },

  grading_notes: {
    friendly: 'Notes',
    validations: {},
    typeHint: typeHints.TextArea,
  },

  ownership_status: {
    friendly: 'Ownership Status',
    validations: {
      type: 'enum',
      enumType: OwnershipStatus,
      default: OwnershipStatus['In Collection'],
    },
  },

  location: {
    friendly: 'Location',
    validations: {
      maxLength: 100,
    },
  },

  specific_location: {
    friendly: 'Specific Location',
    validations: {
      maxLength: 100,
    },
  },

  location_history: {
    friendly: 'Location History',
    validations: {
      maxLength: 100,
    },
  },

  sale_value: {
    friendly: 'Sale Value',
    validations: {
      type: 'decimal',
    },
    typeHint: typeHints.Monetary,
  },

  sale_date: {
    friendly: 'Sale Date',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },

};

export default attributes;



// WEBPACK FOOTER //
// ./src/config/itemDataAttributes.js